import { React, useState, useContext, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Paper } from '@mui/material';
import { FormControl, Select, MenuItem, InputLabel, TextField } from '@mui/material';
import postData from './postData.js';
import { AuthContext } from './AuthContext.js';
import { useParams, useNavigate } from 'react-router-dom';
import Loadingalert from './LoadingAlert';

import Tiptap from './TipTap.tsx';

// date picker stuff
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

const PageEventEdit = () => {

  //form variables
  const { baseURL, isAdministrator, neighborhoodSK } = useContext(AuthContext);
  const editorRef = useRef(null) //reference to tiptap editor
  const navigate = useNavigate();

  const { id } = useParams();  //get parameter from router
  const [isInitialized, setIsInitialized] = useState(false);
  const [submitting, setSubmitting] = useState(false);


  //issue values
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [eventType, setEventType] = useState("");
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [neighborhoodSKValue, setNeighborhoodSKValue] = useState("");
  const [rsEvent, setrsEvent] = useState(undefined);



  //warning dialog variables
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  //vars supporting combo box
  const [rsCombo, setrsCombo] = useState(undefined);
  const [neighborhoodSKTemp, setNeighborhoodSKTemp] = useState('');
  const [isComboDataFetched, SetisComboDataFetched] = useState(false);
  const [isNeighborhoodComboDisabled, setIsNeighborhoodComboDisabled] = useState(false);

  //vars to handle delete
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  //---------------------------------------------------
  // initialize the event values

  const retrieveEventInfo = async () => {
    const formData = new FormData();
    formData.append('ccnaEventSK', id);
    var objData = await postData(baseURL + 'ccnaEventSelect.php', formData);
    if (objData.theError === "") {
      setrsEvent(objData.theData);
    } else {
      setErrorMessage(objData.theError);
    }
  }

  useEffect(() => {
    if (isInitialized === false) {
      if (id === '0') {
        setTitle('');
        setNeighborhoodSKTemp(0);
        setBody('');
        setEventLocation('');
        setEventType(1);
        setDateStart('');
        setDateEnd('');
        setIsInitialized(true);
      } else {
        retrieveEventInfo();
      }
    }
    // eslint-disable-next-line     
  }, [isInitialized, id])

  useEffect(() => {
    if (rsEvent !== undefined) {
      setTitle(rsEvent[0].title);
      setNeighborhoodSKTemp(rsEvent[0].neighborhoodSK);
      setEventLocation(rsEvent[0].eventLocation);
      setEventType(rsEvent[0].eventType);
      setDateStart(rsEvent[0].dateStart);
      setDateEnd(rsEvent[0].dateEnd);
      setBody(rsEvent[0].body);

      setIsInitialized(true);
    }
  }, [rsEvent, baseURL])

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.setContent(body);
    }
  }, [body])


  // ----------------------------------------------------
  // get neighborhood list from server
  useEffect(() => {
    const getSelectOptions = async () => {
      const formData = new FormData();
      var objSelect = await postData(baseURL + 'ccnaEventNeighborhoodSelect.php', formData);
      setErrorMessage(objSelect.theError);
      if (objSelect.theData != null) {
        setrsCombo(objSelect.theData);
        SetisComboDataFetched(true)
      }
    }
    if (rsCombo === undefined) {
      getSelectOptions();
    }
  })
  // now that the neighborhood and the event is retrieved, set the neighborhood value
  useEffect(() => {
    if (isInitialized === true && isComboDataFetched === true) {
      //if not an administrator, then set neighborhood to user's neighborhood
      if (isAdministrator !== '1') {
        setNeighborhoodSKValue(neighborhoodSK);
        setIsNeighborhoodComboDisabled(true);
      } else {
        setNeighborhoodSKValue(neighborhoodSKTemp);
      }
    }
    // eslint-disable-next-line
  }, [isInitialized, isComboDataFetched])

  //-------------------------------------------------------------
  // functions to handle delete functionality

  const handleItemDelete = () => {
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogCancel = () => {
    setOpenDeleteDialog(false);
  }

  const handleDeleteDialogOK = async () => {
    // close the dialog
    setOpenDeleteDialog(false);

    //save to database
    const formData = new FormData();
    formData.append('ccnaEventSK', id);
    let objData = await postData(baseURL + 'ccnaEventDelete.php', formData);
    if (objData.theError === "") {
      // refresh topic list
      navigate('/');
    } else {
      setErrorMessage(objData.theError);
    }

  }

  // ----- handle user warning
  useEffect(() => {
    if (errorMessage !== '') {
      setOpenWarningDialog(true);
    }
  }, [errorMessage]
  )

  //---------------------------------------------------
  // other buttons
  const handleCancel = () => {
    navigate('/');
  };
  //---------------------------------------------------
  // processing saving
  const saveComment = async () => {
    let isComplete = true;

    // get content from tiptap editor

    let bodyComment = "";
    if (editorRef.current) {
      bodyComment = editorRef.current.getHTML();
    }

    // perform additional validity checkings
    if (title === '') {
      isComplete = false;
      setErrorMessage("Please enter a title.");
    }



    if (isComplete) {
      setSubmitting(true);

      //save to database
      const formData = new FormData();
      formData.append('ccnaEventSK', id);
      formData.append('title', title);
      formData.append('body', bodyComment);
      formData.append('eventLocation', eventLocation);
      formData.append('eventType', eventType);
      formData.append('dateStart', dayjs(dateStart).format('YYYY-MM-DD HH:mm:ss'));
      formData.append('dateEnd', dayjs(dateEnd).format('YYYY-MM-DD HH:mm:ss'));
      formData.append('neighborhoodSK', neighborhoodSKValue);
      formData.append('eventLocation', eventLocation);
      let objData = await postData(baseURL + 'ccnaEventAddEdit.php', formData);
      if (objData.theError === "") {
        //go back to home screen
        navigate(`/`);
      } else {
        setErrorMessage(objData.theError);
        setSubmitting(true);
      }
    }  //isComplete
  };


  //---------------------------------------------------
  // ----- handle user warning
  useEffect(() => {
    if (errorMessage !== '') {
      setOpenWarningDialog(true);
    }
  }, [errorMessage]
  )
  const handleDialogOK = () => {
    setOpenWarningDialog(false);
    setErrorMessage('');
  };


  //---------------------------------------------------
  return (<>
    {(isInitialized === false) && <Loadingalert />}
    <div style={{margin:'0px',padding:'0'}}>
      <Paper elevation={10} style={{ margin: '5px' }}>
        <h4 style={{ paddingTop: '15px', paddingLeft: '15px', marginBottom: '20px' }}>Editing Event</h4>
        <Formik
          initialValues={{
            fullName: '',
            email: '',
          }}
          onSubmit={async (values) => {
            saveComment();
          }}
        >
          <Form style={{ textAlign: "left", paddingLeft: 10, marginTop: 0 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div style={{ display: 'flex', gap: '20px' }}>
                <TextField
                  id="title-textfiled"
                  label="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  style={{ width: "45%" }}
                  required
                />
                <FormControl style={{ width: '25%' }}>
                  <InputLabel id="eventType-select-label">Type</InputLabel>
                  <Select
                    labelId="eventType-select-label"
                    id="eventType-select"
                    value={eventType}
                    label="Age"
                    onChange={(e) => setEventType(e.target.value)}
                  >
                    <MenuItem value={1}>Meeting</MenuItem>
                    <MenuItem value={2}>Activity</MenuItem>
                    <MenuItem value={3}>Party</MenuItem>
                    <MenuItem value={4}>Development</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div style={{ display: 'flex', gap: '20px' }}>
                <TextField
                  id="eventLocation-textfiled"
                  label="Location"
                  value={eventLocation}
                  onChange={(e) => setEventLocation(e.target.value)}
                  style={{ width: "45%" }}
                  required
                />
                <FormControl style={{ width: "25%" }}>
                  <InputLabel id="neighborhood-select-label">Neighborhood</InputLabel>
                  <Select
                    labelId="neighborhood-simple-select-label"
                    id="neighborhood-select"
                    value={neighborhoodSKValue}
                    disabled={isNeighborhoodComboDisabled}
                    label="Neighborhood"
                    onChange={(e) => setNeighborhoodSKValue(e.target.value)}
                  >
                    {(rsCombo) && rsCombo.map((option) => (
                      <MenuItem key={option.sk} value={option.sk}>
                        {option.fullName}
                      </MenuItem>))}
                  </Select>
                </FormControl>


              </div>

              <div style={{ display: 'flex', gap: '20px' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    label="Start"
                    value={dayjs(dateStart)}
                    onChange={(newValue) => setDateStart(newValue)}
                    required
                    views={['year', 'month', 'day', 'hours', 'minutes']}
                  />
                  <TimePicker
                    label="End"
                    value={dayjs(dateEnd)}
                    onChange={(newValue) => setDateEnd(newValue)}
                    required
                    views={['year', 'month', 'day', 'hours', 'minutes']}
                  />
                </LocalizationProvider>
              </div>

            </div>


            <div style={{ paddingTop: '15px', marginRight: '10px' }}>
              <Tiptap ref={editorRef} content={body} />
            </div>
            <div className='formButtonContainer'>
              <Button disabled={submitting} variant='contained' onClick={handleCancel}>Cancel</Button>
              <Button type="submit" loading={submitting} disabled={submitting} variant='contained'>Save</Button>
              <Button disabled={submitting} variant='contained' sx={{ bgcolor: 'red', color: 'white' }} onClick={handleItemDelete}>Delete</Button>
            </div>
          </Form>
        </Formik></Paper>
    </div>
    <Dialog
      open={openWarningDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Alert
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogOK}>Ok</Button>
      </DialogActions>
    </Dialog>
    {/**** Delete dialog  ******/}
    <Dialog
      open={openDeleteDialog}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        Event Deletion
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          Are you sure you want to delete this event?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeleteDialogCancel}>Cancel</Button>
        <Button onClick={handleDeleteDialogOK}>Delete</Button>
      </DialogActions>
    </Dialog>
  </>

  );
};

export default PageEventEdit;